import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Pagination from "rc-pagination";
import Switch from "react-switch";
import Fancybox from "../../Component/FancyBox";
import $ from "jquery";
import {
  StampCategoryDropdown,
  StampIsPremium,
  StampIsPremiumIos,
  StampStatus,
  StampStatusIos,
  StampUpdatePostion,
  StampsAll,
  StampsDelete,
} from "../../Auth/Api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { SelectPicker } from "rsuite";

const Stamps = () => {
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [current, setCurrent] = useState(1);
  const [loading, setLoading] = useState(true);
  const [Data, SetData] = useState([]);
  const [categoryDropdownArray, setCategoryDropdownArray] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [search, setSearch] = useState("");

  const [filters, setFilters] = useState({
    is_premium: "",
    is_premium_ios: "",
    status: "",
    status_ios: "",
  });

  const GetData = async () => {
    const Result = await StampsAll({ category_id: categoryId, search });

    if (Result?.data?.Status === true) {
      SetData(Result?.data?.Data);
      setLoading(false);
    } else {
      SetData([]);
      setLoading(false);
    }
  };

  let count = 10;
  let swalCountdownInterval;

  const DeleteStamp = async (id) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger btn-lg counter",
        cancelButton: "btn btn-primary btn-lg me-3",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to delete?",
        text: "You won't be able to revert this!",
        imageUrl: "../../icon/alert.svg",
        imageWidth: 80,
        imageHeight: 80,
        confirmButtonText: "OK (10)",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        reverseButtons: true,
        didOpen: () => {
          $(".swal2-confirm").attr("disabled", true);
          swalCountdownInterval = setInterval(function () {
            count--;
            if (count < 1) {
              $(".counter").text(`OK`);
              $(".swal2-confirm").attr("disabled", false);
              clearInterval(swalCountdownInterval);
            } else {
              $(".counter").text(`OK (${count})`);
            }
          }, 1000);
        },
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const Result = await StampsDelete(id);
          if (Result?.data?.Status === true) {
            setLoading(false);
            setCurrent(1);
            toast.success("Stamps Delete Successfully...");
            GetData();
          } else {
            toast.error(Result?.data?.Response_Message);
          }
        } else {
          count = 10;
          clearInterval(swalCountdownInterval);
        }
      });
  };

  const changeIsPremium = async (e, id) => {
    const Result = await StampIsPremium(e === true ? 1 : 0, id);
    if (Result?.data?.Status === true) {
      toast.success("Is Premium Update Successfully...");
      GetData();
    } else {
      toast.error(Result?.data?.Response_Message);
    }
  };

  const changeIsPremiumIos = async (e, id) => {
    const Result = await StampIsPremiumIos(e === true ? 1 : 0, id);
    if (Result?.data?.Status === true) {
      toast.success("Is Premium Ios Update Successfully...");
      GetData();
    } else {
      toast.error(Result?.data?.Response_Message);
    }
  };

  const changeStatus = async (e, id) => {
    const Result = await StampStatus(e === true ? 1 : 0, id);
    if (Result?.data?.Status === true) {
      toast.success("Status Update Successfully...");
      GetData();
    } else {
      toast.error(Result.data.Response_Message);
    }
  };

  const changeStatusIos = async (e, id) => {
    const Result = await StampStatusIos(e === true ? 1 : 0, id);
    if (Result?.data?.Status === true) {
      toast.success("Status Ios Update Successfully...");
      GetData();
    } else {
      toast.error(Result.data.Response_Message);
    }
  };

  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return <button className="paggination-btn">Previous</button>;
    }
    if (type === "next") {
      return <button className="paggination-btn">Next</button>;
    }
    return originalElement;
  };

  const categoryDropdown = async () => {
    const Result = await StampCategoryDropdown();

    const options = [
      { label: "All Categories", value: "all" },
      ...(Result?.data?.Data?.map((val) => ({
        label: val.name,
        value: val._id,
      })) || []),
    ];

    setCategoryDropdownArray(options);
  };

  const handleOnChangeSelect = (e) => {
    setCategoryId(e !== "all" ? e : "");
  };

  useEffect(() => {
    categoryDropdown();
  }, []);

  useEffect(() => {
    GetData();
  }, [categoryId]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setSearch(e.target.value);
      GetData();
    }
  };

  const filteredData = useMemo(() => {
    let filtered = [...Data];

    if (filters.is_premium !== "") {
      filtered = filtered.filter(
        (item) => item.is_premium === Number(filters.is_premium),
      );
    }

    if (filters.is_premium_ios !== "") {
      filtered = filtered.filter(
        (item) => item.is_premium_ios === Number(filters.is_premium_ios),
      );
    }

    if (filters.status !== "") {
      filtered = filtered.filter(
        (item) => item.status === Number(filters.status),
      );
    }

    if (filters.status_ios !== "") {
      filtered = filtered.filter(
        (item) => item.status_ios === Number(filters.status_ios),
      );
    }

    setCurrent(1);
    return filtered;
  }, [Data, filters]);

  const stampData = useMemo(() => {
    return filteredData.slice((current - 1) * size, current * size);
  }, [filteredData, current, size]);

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const PerPageChange = (value) => {
    setSize(value);
    setCurrent(1);
  };

  const handleOnDragEnd = async (result) => {
    const { source, destination } = result;

    if (!destination) return;

    const items = Array.from(stampData);

    const [reorderedItem] = items.splice(source.index, 1);

    items.splice(destination.index, 0, reorderedItem);

    const ids = items.map((item) => item._id);

    const pageInformation = {
      currentPage: current,
      sourceIndex: source.index,
      destinationIndex: destination.index,
    };

    const updatePotion = await StampUpdatePostion(ids, pageInformation);

    if (updatePotion?.data?.Status) {
      toast.success("Position Update Successfully...");
      GetData();
    } else {
      toast.error(updatePotion?.data?.Response_Message);
    }
  };

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">
          Stamps{" "}
          <span style={{ color: "#0093ed" }}>({filteredData.length})</span>
        </h3>
        <div className="page-heading-right justify-content-end gap-3">
          <div style={{ width: "220px", position: "relative" }}>
            <Form.Control
              type="text"
              className="my-2"
              placeholder="Search stamp name..."
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleKeyDown}
              value={search}
            />
            <i
              className="bx bx-search-alt text-muted"
              style={{
                fontSize: "18px",
                position: "absolute",
                right: "0.75rem",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
              onClick={() => GetData()}
            />
          </div>
          <SelectPicker
            data={categoryDropdownArray}
            cleanable={false}
            onChange={(e) => handleOnChangeSelect(e)}
            value={Data.category_id}
            block
            className="my-2"
            placeholder="Select Category"
          />
          <Form.Select
            value={filters.is_premium}
            onChange={(e) =>
              setFilters({ ...filters, is_premium: e.target.value })
            }
            className="w-auto"
            id="isPremiumFilter"
          >
            <option value="">All Premium</option>
            <option value={1}>Premium</option>
            <option value={0}>Free</option>
          </Form.Select>
          <Form.Select
            value={filters.is_premium_ios}
            onChange={(e) =>
              setFilters({ ...filters, is_premium_ios: e.target.value })
            }
            className="w-auto"
            id="isPremiumIosFilter"
          >
            <option value="">All iOS Premium</option>
            <option value={1}>Premium</option>
            <option value={0}>Free</option>
          </Form.Select>
          <Form.Select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            className="w-auto"
            id="statusFilter"
          >
            <option value="">All Status</option>
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </Form.Select>
          <Form.Select
            value={filters.status_ios}
            onChange={(e) =>
              setFilters({ ...filters, status_ios: e.target.value })
            }
            className="w-auto"
            id="statusIosFilter"
          >
            <option value="">All iOS Status</option>
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </Form.Select>
          <Link to="/Stamps/Add" className="my-1 ms-0">
            <Button variant="primary" value="create">
              Add New
            </Button>
          </Link>
        </div>
      </div>
      <div className="page-content">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                {loading === true ? (
                  <div className="loader table-loader"></div>
                ) : (
                  <></>
                )}
                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th width="3%" className="text-center">
                        No
                      </th>
                      <th width="7%" className="text-center">
                        Thumb Image
                      </th>
                      <th width="7%" className="text-center">
                        Image
                      </th>
                      <th width="7%" className="text-center">
                        BG Image
                      </th>
                      <th width="8%" className="text-center">
                        Transparent Image
                      </th>
                      <th width="8%">Category Name</th>
                      <th width="9%">Stamp Name</th>
                      <th width="6%" className="text-center">
                        Zip Name
                      </th>
                      <th width="8%" className="text-center">
                        Zip Name iOS
                      </th>
                      <th width="8%" className="text-center">
                        Is Premium
                      </th>
                      <th width="9%" className="text-center">
                        Is Premium iOS
                      </th>
                      <th width="6%" className="text-center">
                        Status
                      </th>
                      <th width="7%" className="text-center">
                        Status iOS
                      </th>
                      <th width="7%" className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="stamps">
                      {(provided) => (
                        <tbody
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {!loading && stampData.length === 0 ? (
                            <tr>
                              <td colSpan="100%" className="p-0">
                                <div className="no-found">
                                  <img
                                    src="../../../not-found/stamp.svg"
                                    alt="stamp-image"
                                  />
                                  <p>No Found Stamps</p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {stampData.length > 0 &&
                                stampData.map((val, index) => {
                                  return (
                                    <Draggable
                                      key={val._id}
                                      draggableId={val._id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => {
                                        return (
                                          <tr
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            ref={provided.innerRef}
                                            isDragging={snapshot.isDragging}
                                          >
                                            <td className="text-center">
                                              {current === 1
                                                ? index + 1
                                                : current * size +
                                                  index +
                                                  1 -
                                                  size}
                                            </td>
                                            <td className="text-center">
                                              {val?.thumb_image ? (
                                                <Fancybox>
                                                  <a
                                                    href={val.thumb_image}
                                                    data-fancybox="gallery"
                                                  >
                                                    <img
                                                      src={val.thumb_image}
                                                      alt="Thumb img"
                                                      className="hv-40 rounded-3"
                                                    />
                                                  </a>
                                                </Fancybox>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="text-center">
                                              {val?.stamp_image ? (
                                                <Fancybox>
                                                  <a
                                                    href={val.stamp_image}
                                                    data-fancybox="gallery"
                                                  >
                                                    <img
                                                      src={val.stamp_image}
                                                      alt="stamp img"
                                                      className="hv-40 rounded-3"
                                                    />
                                                  </a>
                                                </Fancybox>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="text-center">
                                              {val?.stamp_background_image ? (
                                                <Fancybox>
                                                  <a
                                                    href={
                                                      val.stamp_background_image
                                                    }
                                                    data-fancybox="gallery"
                                                  >
                                                    <img
                                                      src={
                                                        val.stamp_background_image
                                                      }
                                                      alt="stamp background img"
                                                      className="hv-40 rounded-3"
                                                    />
                                                  </a>
                                                </Fancybox>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="text-center">
                                              {val?.tansparent_image ? (
                                                <Fancybox>
                                                  <a
                                                    href={val?.tansparent_image}
                                                    data-fancybox="gallery"
                                                  >
                                                    <img
                                                      src={
                                                        val?.tansparent_image
                                                      }
                                                      alt="transparent img"
                                                      className="hv-40 rounded-3"
                                                    />
                                                  </a>
                                                </Fancybox>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td>
                                              {val?.category?.name || "-"}
                                            </td>
                                            <td>{val?.name || "-"}</td>
                                            <td className="text-center">
                                              <a href={val.zip_name}>
                                                {val.zip_name === "" ||
                                                val.zip_name === "NA" ? (
                                                  "-"
                                                ) : (
                                                  <a href={val.zip_name}>
                                                    <Button
                                                      variant="outline-info"
                                                      size="sm"
                                                      className="btn-icon"
                                                    >
                                                      <i className="bx bx-download"></i>
                                                    </Button>
                                                  </a>
                                                )}
                                              </a>
                                            </td>
                                            <td className="text-center">
                                              <a href={val.zip_name_ios}>
                                                {val.zip_name_ios === "" ||
                                                val.zip_name_ios === "NA" ? (
                                                  "-"
                                                ) : (
                                                  <a href={val.zip_name_ios}>
                                                    <Button
                                                      variant="outline-info"
                                                      size="sm"
                                                      className="btn-icon"
                                                    >
                                                      <i className="bx bx-download"></i>
                                                    </Button>
                                                  </a>
                                                )}
                                              </a>
                                            </td>
                                            <td className="text-center">
                                              <Switch
                                                onChange={(e) => {
                                                  changeIsPremium(e, val._id);
                                                }}
                                                checked={
                                                  val.is_premium === 1
                                                    ? true
                                                    : false
                                                }
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                  <div className="react-switch-off">
                                                    NO
                                                  </div>
                                                }
                                                checkedIcon={
                                                  <div className="react-switch-on">
                                                    YES
                                                  </div>
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              <Switch
                                                onChange={(e) => {
                                                  changeIsPremiumIos(
                                                    e,
                                                    val._id,
                                                  );
                                                }}
                                                checked={
                                                  val.is_premium_ios === 1
                                                    ? true
                                                    : false
                                                }
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                  <div className="react-switch-off">
                                                    NO
                                                  </div>
                                                }
                                                checkedIcon={
                                                  <div className="react-switch-on">
                                                    YES
                                                  </div>
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              <Switch
                                                onChange={(e) => {
                                                  changeStatus(e, val._id);
                                                }}
                                                checked={
                                                  val.status === 1
                                                    ? true
                                                    : false
                                                }
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                  <div className="react-switch-off">
                                                    OFF
                                                  </div>
                                                }
                                                checkedIcon={
                                                  <div className="react-switch-on">
                                                    ON
                                                  </div>
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              <Switch
                                                onChange={(e) => {
                                                  changeStatusIos(e, val._id);
                                                }}
                                                checked={
                                                  val.status_ios === 1
                                                    ? true
                                                    : false
                                                }
                                                offColor="#C8C8C8"
                                                onColor="#0093ed"
                                                height={30}
                                                width={70}
                                                className="react-switch"
                                                uncheckedIcon={
                                                  <div className="react-switch-off">
                                                    OFF
                                                  </div>
                                                }
                                                checkedIcon={
                                                  <div className="react-switch-on">
                                                    ON
                                                  </div>
                                                }
                                              />
                                            </td>
                                            <td className="text-center">
                                              <Link
                                                to={`/Stamps/View/${val._id}`}
                                              >
                                                <Button
                                                  variant="outline-warning"
                                                  size="sm"
                                                  className="me-2 btn-icon"
                                                >
                                                  <i className="bx bx-show"></i>
                                                </Button>
                                              </Link>
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                className="btn-icon"
                                                onClick={() =>
                                                  DeleteStamp(val._id)
                                                }
                                              >
                                                <i className="bx bx-trash-alt"></i>
                                              </Button>
                                            </td>
                                          </tr>
                                        );
                                      }}
                                    </Draggable>
                                  );
                                })}
                            </>
                          )}
                        </tbody>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Table>
                {filteredData.length > size && (
                  <div className="pagination-custom">
                    <Pagination
                      className="pagination-data"
                      onChange={PaginationChange}
                      total={filteredData.length}
                      current={current}
                      pageSize={size}
                      showSizeChanger={false}
                      itemRender={PrevNextArrow}
                      onShowSizeChange={PerPageChange}
                      showTitle={false}
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default Stamps;
